"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestEncode = requestEncode;
var _qs = _interopRequireDefault(require("qs"));
var Base64 = require('js-base64').Base64;
function requestEncode(query) {
  var queryStr = _qs.default.stringify(query, {
    indices: false
  });
  var pas = 'DfEqd%AvjY1!pFE';
  var baseStr = pas + Base64.encode(queryStr);
  var queryParams = {
    "queryParams": baseStr
  };
  return queryParams;
}